import { Cancel, Edit, Save } from '@mui/icons-material';
import { Box, IconButton, TextField, Typography } from '@mui/material';

export default function EditWalletName({
  isEditing,
  walletName,
  handleTextChange,
  handleBlur,
  handleKeyPress,
  handleSave,
  handleCancel,
  handleTextClick,
}: {
  isEditing: boolean;
  walletName: string;
  handleTextChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlur: () => void;
  handleKeyPress: (event: React.KeyboardEvent) => void;
  handleSave: () => void;
  handleCancel: () => void;
  handleTextClick: () => void;
}) {
  return isEditing ? (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <TextField
        value={walletName}
        onChange={handleTextChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyPress}
        autoFocus
        variant="standard"
        fullWidth
        InputProps={{
          style: {
            fontSize: '1.25rem',
            fontWeight: 500,
            fontFamily: 'inherit',
          },
        }}
        sx={{
          '& .MuiInputBase-root': {
            '&:before': {
              borderBottom: 'none',
            },
            '&:after': {
              borderBottom: 'none',
            },
            '&:hover:not(.Mui-disabled):before': {
              borderBottom: 'none',
            },
          },
        }}
      />
      <IconButton
        onMouseDown={(e) => {
          e.preventDefault();
          handleSave();
        }}
        color="primary"
        size="small"
        title="Salvar">
        <Save color="primary" />
      </IconButton>
      <IconButton
        onMouseDown={(e) => {
          e.preventDefault();
          handleCancel();
        }}
        color="error"
        size="small"
        title="Cancelar">
        <Cancel color="error" />
      </IconButton>
    </Box>
  ) : (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography
        variant="h6"
        onClick={handleTextClick}
        sx={{
          cursor: 'pointer',
          flex: 1,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}>
        Editar Carteira - {walletName}
      </Typography>
      <IconButton
        onClick={handleTextClick}
        size="small"
        title="Editar nome da carteira"
        sx={{
          opacity: 0.7,
          '&:hover': {
            opacity: 1,
          },
        }}>
        <Edit color="primary" />
      </IconButton>
    </Box>
  );
}
